module.exports = __webpack_public_path__ + "images/dice-icon-halloween-cf2be661fa5f7964776e8a52adcb3f3c.png";